module.exports = __webpack_public_path__ + "media/components/assets/icons/company_together-02cdfc15662bf4d8b91d0a9a7428928d.svg";